import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

import { filter, map } from 'rxjs'

import { RxStateComponent } from '@alliance/shared/models'
import { PublicClubPostsSortingEnum } from '@alliance/clubs/domain'

import { Translations } from '../../localization/translations'

@Component({
  selector: 'alliance-clubs-posts-sorting',
  templateUrl: './sorting.component.html',
  styleUrls: ['./sorting.component.tw.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SortingComponent extends RxStateComponent<{
  showPopularityItems: boolean
  sortingPopularityItems: PublicClubPostsSortingEnum[]
  selectedSorting: PublicClubPostsSortingEnum | null
}> {
  @Output() public OutSelectedSorting = new EventEmitter<PublicClubPostsSortingEnum | null>()

  public readonly SortingEnum = PublicClubPostsSortingEnum

  public state = this.connectViewState(['showPopularityItems', 'selectedSorting', 'sortingPopularityItems'])

  public constructor(public translations: Translations) {
    super()

    this.initState({
      showPopularityItems: this.select('selectedSorting').pipe(
        filter((selected): selected is PublicClubPostsSortingEnum => !!selected),
        map(selected => this.get().sortingPopularityItems.includes(selected))
      ),
      sortingPopularityItems: [PublicClubPostsSortingEnum.ByWeek, PublicClubPostsSortingEnum.ByMonth, PublicClubPostsSortingEnum.ByYear],
      selectedSorting: null
    })
  }

  @Input()
  public set InpSelectedSorting(value: PublicClubPostsSortingEnum) {
    this.set({ selectedSorting: value })
  }

  public selectSorting(sort: Partial<PublicClubPostsSortingEnum> | null): void {
    this.OutSelectedSorting.emit(sort)
  }

  public getKeyAsSortingEnum(key: unknown): PublicClubPostsSortingEnum {
    return key as PublicClubPostsSortingEnum
  }
}
